import React from 'react';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { SystemIntro } from './components/SystemIntro';
import { Tomos } from './components/Tomos';
import { Bonuses } from './components/Bonuses';
import { WhyGlobal } from './components/WhyGlobal';
import { Offer } from './components/Offer';
import { Outcomes } from './components/Outcomes';
import { Guarantee } from './components/Guarantee';
import { Faq } from './components/Faq';
import { FinalCta } from './components/FinalCta';
import { Footer } from './components/Footer';
type AppProps = {
  showUrgency?: boolean;
};
export function App({
  showUrgency = true
}: AppProps) {
  return <div className="w-full bg-sand font-sans text-ink" data-id="element-0" data-mp="2wk9y4kb1ymz3">
      <Hero data-id="element-1" data-mp="2wip734ny5m5z" />
      <main data-id="element-2" data-mp="2wi5mthatqlos">
        <PainPoints data-id="element-3" data-mp="28ufoscpxzgjl" />
        <SystemIntro data-id="element-4" data-mp="28tw972nrl48q" />
        <Tomos data-id="element-5" data-mp="28t4lsf4bmctj" />
        <Bonuses data-id="element-6" data-mp="28sl3gxardmez" />
        <WhyGlobal data-id="element-7" data-mp="28s2y9b64bxux" />
        <Offer showUrgency={showUrgency} data-id="element-8" data-mp="23vkvggucm9l8" />
        <Outcomes data-id="element-9" data-mp="23ujl6el5pr4k" />
        <Guarantee data-id="element-10" data-mp="23v2uj6wqr76z" />
        <Faq data-id="element-11" data-mp="3ijxpcqos80jw" />
        <FinalCta showUrgency={showUrgency} data-id="element-12" data-mp="3ik7ekc2063oj" />
      </main>
      <Footer data-id="element-13" data-mp="3ijpcuzwkmx98" />
    </div>;
}